const initialeState = {
    'pubKey' : null,
    'subscriptionPrices' : [],
    'displayCheckout' : false,
    'selectedPrice' : null,
    'selectedTerr' : [],
    'paymentIntent' : null,
}

const StripeReducer = (state=initialeState, action) => {
    switch (action.type) {
        case "SET_PUB_KEY":
            return {
                ...state,
                pubKey:  action.data
            }
        case "SET_PAYMENT_INTENT":
            return {
                ...state,
                paymentIntent:  action.data
            }
        case "SET_SUBSCRIPTION_PRICES":
            return {
                ...state,
                subscriptionPrices:   action.data
            }
        case 'SET_DISPLAY_CHECKOUT':
            return {
                ...state,
                displayCheckout:  action.data
            }
        case 'SET_SELECTED_PRICE':
            return {
                ...state,
                selectedPrice: action.data
            }
        case 'SET_SELECTED_TERR':
            action.data.length <= 0
        return {
            ...state,
            selectedTerr: action.data,
            displayCheckout : (action.data.length <= 0 )?false:null
        }
        default:
            return state
    }
}

export default StripeReducer
